import React, { useEffect, useState } from 'react';
import api from '../api';
import { exportRowsToExcel } from '../exportExcel';

const SUBJECT_GROUPS = [
  { key: '항공법규', label: '법규' },
  { key: '정비일반', label: '일반' },
  { key: '항공기체', label: '기체' },
  { key: '항공발동기', label: '발동기' },
  { key: '전자·전기·계기(기본)', label: '전기전자' },
];

export default function EducationDays() {
  const [grade, setGrade] = useState(3);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    api
      .get('/admin/education-days', { params: { grade } })
      .then((res) => setRows(res.data))
      .finally(() => setLoading(false));
  }, [grade]);

  const subjectByKey = (r, key) => r.subjects.find((s) => s.subject === key) || { thry_days: 0, prac_days: 0, total_days: 0 };

  const handleExport = () => {
    const header1 = ['번호', '학번', '이름'];
    SUBJECT_GROUPS.forEach((g) => header1.push(g.label, ''));
    header1.push('계', '');
    const header2 = ['', '', ''];
    SUBJECT_GROUPS.forEach(() => header2.push('학과/실습', '계'));
    header2.push('학과/실습', '계');

    const dataRows = rows.map((r, i) => {
      const row = [i + 1, r.studid, r.name];
      SUBJECT_GROUPS.forEach((g) => {
        const s = subjectByKey(r, g.key);
        row.push(`${s.thry_days} / ${s.prac_days}`, s.total_days);
      });
      row.push(`${r.overall_thry_days} / ${r.overall_prac_days}`, r.overall_total_days);
      return row;
    });

    // 헤더 2줄의 colSpan/rowSpan을 엑셀 셀 병합으로 그대로 표현한다
    const merges = [
      { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } }, // 번호
      { s: { r: 0, c: 1 }, e: { r: 1, c: 1 } }, // 학번
      { s: { r: 0, c: 2 }, e: { r: 1, c: 2 } }, // 이름
    ];
    SUBJECT_GROUPS.forEach((_, i) => {
      const col = 3 + i * 2;
      merges.push({ s: { r: 0, c: col }, e: { r: 0, c: col + 1 } });
    });
    const totalGroupCol = 3 + SUBJECT_GROUPS.length * 2;
    merges.push({ s: { r: 0, c: totalGroupCol }, e: { r: 0, c: totalGroupCol + 1 } }); // 계 그룹

    exportRowsToExcel(`${grade}학년_교육일수.xlsx`, [header1, header2, ...dataRows], merges);
  };

  return (
    <div className="page">
      <div className="page-header">
        <h2>항공정비사과정 교육일수</h2>
        <button className="btn-ghost" type="button" onClick={handleExport}>Excel로 내보내기</button>
      </div>

      <div className="card">
        <div className="form-row">
          <div className="form-field form-field-narrow">
            <label>학년</label>
            <select value={grade} onChange={(e) => setGrade(Number(e.target.value))}>
              <option value={1}>1학년</option>
              <option value={2}>2학년</option>
              <option value={3}>3학년</option>
            </select>
          </div>
        </div>

        <div className="table-scroll">
          <table className="data-table education-days-table">
            <thead>
              <tr>
                <th rowSpan={2}>번호</th>
                <th rowSpan={2}>학번</th>
                <th rowSpan={2}>이름</th>
                {SUBJECT_GROUPS.map((g) => (
                  <th key={g.key} colSpan={2}>{g.label}</th>
                ))}
                <th colSpan={2}>계</th>
              </tr>
              <tr>
                {SUBJECT_GROUPS.map((g) => (
                  <React.Fragment key={g.key}>
                    <th>학과/실습</th>
                    <th>계</th>
                  </React.Fragment>
                ))}
                <th>학과/실습</th>
                <th>계</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.studid}>
                  <td>{i + 1}</td>
                  <td>{r.studid}</td>
                  <td>{r.name}</td>
                  {SUBJECT_GROUPS.map((g) => {
                    const s = subjectByKey(r, g.key);
                    return (
                      <React.Fragment key={g.key}>
                        <td>{s.thry_days} / {s.prac_days}</td>
                        <td>{s.total_days}</td>
                      </React.Fragment>
                    );
                  })}
                  <td>{r.overall_thry_days} / {r.overall_prac_days}</td>
                  <td>{r.overall_total_days}</td>
                </tr>
              ))}
              {!loading && rows.length === 0 && (
                <tr>
                  <td colSpan={3 + SUBJECT_GROUPS.length * 2 + 2} className="empty-row">
                    해당 학년 재학생이 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
